import { api } from "@api/api";
import { UploadImageRes } from "@api/other/put/hooks/useUploadToS3";

const getImageUploadUrl = async () => {
  const { data } = await api.post<UploadImageRes>("/getPlatformAssetUploadUrl");
  return data;
};

export default getImageUploadUrl;
